/**
* 本文件由工具自动生成，请勿手动写入代码，随意修改！！！
* created mengl
* @name Judges
* @description 场次管理
*/
import request from '@/plugins/axios.js';

/** 
 * 获取资源类目
 */
export const getCategorys = () => {
    return request({
        url: '/api/Judges/GetCategorys',
        method: 'get',
    });
}

/** 
 * 添加考试场次
 * @param {Object} body - 场次 
 * @param {body:{"prodevTotal":"integer","storeTotal":"integer","operateFund":"number","roundCount":"integer","stroeTotalTime":"integer","procureTotalTime":"integer","promotionTotalTime":"integer","operateTotalTime":"integer","financeTotalTime":"integer","personNumber":"integer","categoryID":"integer","teamID":"integer"}}
 */
export const addRaceRecords = (data) => {
    return request({
        url: '/api/Judges/AddRaceRecords',
        method: 'post',
        data
    });
}

/** 
 * 获取考试场次信息
 * @param {Integer} page - 页索引 
 */
export const getRaceRecordList = (page) => {
    return request({
        url: '/api/Judges/GetRaceRecordList',
        method: 'get',
        params:{
            page
        }
    });
}

/** 
 * 获取考试场次总条数信息
 */
export const getRaceRecordListCount = () => {
    return request({
        url: '/api/Judges/GetRaceRecordListCount',
        method: 'get',
    });
}

/** 
 * 根据场次id获取场次信息
 * @param {Integer} pageIndex -  
 * @param {Integer} pageSize -  
 * @param {Integer} raceid -  
 */
export const getMatchGroups = (pageIndex, pageSize, raceid) => {
    return request({
        url: '/api/Judges/GetMatchGroups',
        method: 'get',
        params:{
            pageIndex,
            pageSize,
            raceid
        }
    });
}

/** 
 * 导出账号
 * @param {Integer} raceid -  
 */
export const exportGroup = (raceid) => {
    return request({
        url: '/api/Judges/ExportGroup',
        method: 'get',
        params:{
            raceid
        }
    });
}

/** 
 * 解除账号禁用
 * @param {Integer} groupid -  
 */
export const updateMatchGroups = (groupid) => {
    return request({
        url: '/api/Judges/UpdateMatchGroups',
        method: 'post',
        params:{
            groupid
        }
    });
}

/** 
 * 更新密码。
 * @param {String} originalPassword - 原始密码 
 * @param {String} password - 新密码 
 */
export const updatePassword = (originalPassword, password) => {
    return request({
        url: '/api/Judges/UpdatePassword',
        method: 'post',
        params:{
            originalPassword,
            password
        }
    });
}

